var _rect, _path, _path2, _g, _path3, _g2, _rect2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_134)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.9048,
    height: 19.4286,
    transform: "translate(0.190552 0.28611)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 0.286339V19.7149H26.0953V0.286339H0.190552Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_233_134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 0.286339V19.7149H26.0953V0.286339H0.190552Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_233_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13.5836 26.4053L-8.67283 29.0576L39.9773 -7.83437L32.9315 -8.14516L-13.5836 26.4053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.31774 19.3435L0.521883 20.8692L28.6448 -0.335087L24.571 -0.514779L-2.31774 19.3435Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8699 26.4051L34.9592 29.0574L-13.6909 -7.83452L-6.64512 -8.14531L39.8699 26.4051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6041 19.3434L25.7645 20.869L-2.3584 -0.33524L1.71533 -0.514932L28.6041 19.3434Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_233_134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2015 6.76267H27.7367V13.2383H16.2015V21.334H10.0853V13.2383H-1.40588V6.76267H10.0853V-1.33303H16.2015V6.76267Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.2015 6.76267H27.7367V13.2383H16.2015V21.334H10.0853V13.2383H-1.40588V6.76267H10.0853V-1.33303H16.2015V6.76267Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2015 6.76267H14.5825V8.38172H16.2015V6.76267ZM27.7367 6.76267H29.3557V5.14362H27.7367V6.76267ZM27.7367 13.2383V14.8573H29.3557V13.2383H27.7367ZM16.2015 13.2383V11.6192H14.5825V13.2383H16.2015ZM16.2015 21.334V22.953H17.8206V21.334H16.2015ZM10.0853 21.334H8.46628V22.953H10.0853V21.334ZM10.0853 13.2383H11.7044V11.6192H10.0853V13.2383ZM-1.40588 13.2383H-3.02493V14.8573H-1.40588V13.2383ZM-1.40588 6.76267V5.14362H-3.02493V6.76267H-1.40588ZM10.0853 6.76267V8.38172H11.7044V6.76267H10.0853ZM10.0853 -1.33303V-2.95208H8.46628V-1.33303H10.0853ZM16.2015 -1.33303H17.8206V-2.95208H16.2015V-1.33303ZM16.2015 6.76267V8.38172H27.7367V6.76267V5.14362H16.2015V6.76267ZM27.7367 6.76267H26.1176V13.2383H27.7367H29.3557V6.76267H27.7367ZM27.7367 13.2383V11.6192H16.2015V13.2383V14.8573H27.7367V13.2383ZM16.2015 13.2383H14.5825V21.334H16.2015H17.8206V13.2383H16.2015ZM16.2015 21.334V19.7149H10.0853V21.334V22.953H16.2015V21.334ZM10.0853 21.334H11.7044V13.2383H10.0853H8.46628V21.334H10.0853ZM10.0853 13.2383V11.6192H-1.40588V13.2383V14.8573H10.0853V13.2383ZM-1.40588 13.2383H0.213164V6.76267H-1.40588H-3.02493V13.2383H-1.40588ZM-1.40588 6.76267V8.38172H10.0853V6.76267V5.14362H-1.40588V6.76267ZM10.0853 6.76267H11.7044V-1.33303H10.0853H8.46628V6.76267H10.0853ZM10.0853 -1.33303V0.286017H16.2015V-1.33303V-2.95208H10.0853V-1.33303ZM16.2015 -1.33303H14.5825V6.76267H16.2015H17.8206V-1.33303H16.2015Z",
    fill: "white",
    mask: "url(#path-7-inside-1_233_134)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_233_134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.190575 19.7143V0.28569H26.0953L0.190575 19.7143Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_233_134)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 0.285645H26.0953V19.7142H0.190552V0.285645Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 12.159V13.778H26.0953V12.159H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 15.1267V16.7457H26.0953V15.1267H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 6.22194V7.84099H26.0953V6.22194H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 18.0952V19.7143H26.0953V18.0952H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 9.19045V10.8095H26.0953V9.19045H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 0.285645V1.90469H26.0953V0.285645H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.190552 3.25421V4.87326H26.0953V3.25421H0.190552Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.190552,
    y: 0.285645,
    width: 16.1905,
    height: 10.5238,
    fill: "#2E42A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34437 2.18333L3.50262 2.50398L3.85648 2.55539L3.60042 2.80499L3.66087 3.15741L3.34437 2.99102L3.02787 3.15741L3.08832 2.80499L2.83226 2.55539L3.18612 2.50398L3.34437 2.18333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57545 2.18313L6.7337 2.50378L7.08756 2.5552L6.8315 2.80479L6.89195 3.15721L6.57545 2.99082L6.25895 3.15721L6.3194 2.80479L6.06334 2.5552L6.4172 2.50378L6.57545 2.18313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80616 2.18313L9.96441 2.50378L10.3183 2.5552L10.0622 2.80479L10.1227 3.15721L9.80616 2.99082L9.48966 3.15721L9.55011 2.80479L9.29405 2.5552L9.64791 2.50378L9.80616 2.18313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0372 2.18313L13.1955 2.50378L13.5493 2.5552L13.2933 2.80479L13.3537 3.15721L13.0372 2.99082L12.7207 3.15721L12.7812 2.80479L12.5251 2.5552L12.879 2.50378L13.0372 2.18313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34437 3.97861L3.50262 4.29926L3.85648 4.35068L3.60042 4.60027L3.66087 4.9527L3.34437 4.78631L3.02787 4.9527L3.08832 4.60027L2.83226 4.35068L3.18612 4.29926L3.34437 3.97861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5752 3.97861L6.73345 4.29926L7.08731 4.35068L6.83126 4.60027L6.8917 4.9527L6.5752 4.78631L6.2587 4.9527L6.31915 4.60027L6.0631 4.35068L6.41695 4.29926L6.5752 3.97861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80616 3.97861L9.96441 4.29926L10.3183 4.35068L10.0622 4.60027L10.1227 4.9527L9.80616 4.78631L9.48966 4.9527L9.55011 4.60027L9.29405 4.35068L9.64791 4.29926L9.80616 3.97861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.037 3.97861L13.1952 4.29926L13.5491 4.35068L13.2931 4.60027L13.3535 4.9527L13.037 4.78631L12.7205 4.9527L12.7809 4.60027L12.5249 4.35068L12.8787 4.29926L13.037 3.97861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34437 5.77305L3.50262 6.0937L3.85648 6.14512L3.60042 6.39471L3.66087 6.74713L3.34437 6.58074L3.02787 6.74713L3.08832 6.39471L2.83226 6.14512L3.18612 6.0937L3.34437 5.77305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57545 5.77291L6.7337 6.09356L7.08756 6.14498L6.8315 6.39457L6.89195 6.747L6.57545 6.5806L6.25895 6.747L6.3194 6.39457L6.06334 6.14498L6.4172 6.09356L6.57545 5.77291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80616 5.77291L9.96441 6.09356L10.3183 6.14498L10.0622 6.39457L10.1227 6.747L9.80616 6.5806L9.48966 6.747L9.55011 6.39457L9.29405 6.14498L9.64791 6.09356L9.80616 5.77291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0372 5.77291L13.1955 6.09356L13.5493 6.14498L13.2933 6.39457L13.3537 6.747L13.0372 6.5806L12.7207 6.747L12.7812 6.39457L12.5251 6.14498L12.879 6.09356L13.0372 5.77291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34449 7.56866L3.50274 7.88931L3.8566 7.94072L3.60055 8.19032L3.66099 8.54274L3.34449 8.37635L3.02799 8.54274L3.08844 8.19032L2.83238 7.94072L3.18624 7.88931L3.34449 7.56866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57533 7.56866L6.73358 7.88931L7.08743 7.94072L6.83138 8.19032L6.89183 8.54274L6.57533 8.37635L6.25883 8.54274L6.31927 8.19032L6.06322 7.94072L6.41708 7.88931L6.57533 7.56866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80628 7.56866L9.96453 7.88931L10.3184 7.94072L10.0623 8.19032L10.1228 8.54274L9.80628 8.37635L9.48978 8.54274L9.55023 8.19032L9.29418 7.94072L9.64803 7.88931L9.80628 7.56866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0371 7.56866L13.1954 7.88931L13.5492 7.94072L13.2932 8.19032L13.3536 8.54274L13.0371 8.37635L12.7206 8.54274L12.7811 8.19032L12.525 7.94072L12.8789 7.88931L13.0371 7.56866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72901 1.28611L1.88726 1.60676L2.24112 1.65818L1.98507 1.90777L2.04551 2.2602L1.72901 2.0938L1.41251 2.2602L1.47296 1.90777L1.21691 1.65818L1.57076 1.60676L1.72901 1.28611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95985 1.28611L5.1181 1.60676L5.47196 1.65818L5.2159 1.90777L5.27635 2.2602L4.95985 2.0938L4.64335 2.2602L4.70379 1.90777L4.44774 1.65818L4.8016 1.60676L4.95985 1.28611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19081 1.28611L8.34906 1.60676L8.70291 1.65818L8.44686 1.90777L8.50731 2.2602L8.19081 2.0938L7.87431 2.2602L7.93475 1.90777L7.6787 1.65818L8.03256 1.60676L8.19081 1.28611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4218 1.28611L11.58 1.60676L11.9339 1.65818L11.6778 1.90777L11.7383 2.2602L11.4218 2.0938L11.1053 2.2602L11.1657 1.90777L10.9097 1.65818L11.2635 1.60676L11.4218 1.28611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6525 1.28611L14.8107 1.60676L15.1646 1.65818L14.9085 1.90777L14.969 2.2602L14.6525 2.0938L14.336 2.2602L14.3964 1.90777L14.1404 1.65818L14.4942 1.60676L14.6525 1.28611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72901 3.0814L1.88726 3.40205L2.24112 3.45347L1.98507 3.70306L2.04551 4.05548L1.72901 3.88909L1.41251 4.05548L1.47296 3.70306L1.21691 3.45347L1.57076 3.40205L1.72901 3.0814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95985 3.0814L5.1181 3.40205L5.47196 3.45347L5.2159 3.70306L5.27635 4.05548L4.95985 3.88909L4.64335 4.05548L4.70379 3.70306L4.44774 3.45347L4.8016 3.40205L4.95985 3.0814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19081 3.0814L8.34906 3.40205L8.70291 3.45347L8.44686 3.70306L8.50731 4.05548L8.19081 3.88909L7.87431 4.05548L7.93475 3.70306L7.6787 3.45347L8.03256 3.40205L8.19081 3.0814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4216 3.0814L11.5799 3.40205L11.9337 3.45347L11.6777 3.70306L11.7381 4.05548L11.4216 3.88909L11.1051 4.05548L11.1656 3.70306L10.9095 3.45347L11.2634 3.40205L11.4216 3.0814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6525 3.0814L14.8107 3.40205L15.1646 3.45347L14.9085 3.70306L14.969 4.05548L14.6525 3.88909L14.336 4.05548L14.3964 3.70306L14.1404 3.45347L14.4942 3.40205L14.6525 3.0814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72901 4.87583L1.88726 5.19648L2.24112 5.2479L1.98507 5.49749L2.04551 5.84992L1.72901 5.68352L1.41251 5.84992L1.47296 5.49749L1.21691 5.2479L1.57076 5.19648L1.72901 4.87583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95985 4.87571L5.1181 5.19636L5.47196 5.24778L5.2159 5.49737L5.27635 5.8498L4.95985 5.6834L4.64335 5.8498L4.70379 5.49737L4.44774 5.24778L4.8016 5.19636L4.95985 4.87571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19081 4.87589L8.34906 5.19654L8.70291 5.24796L8.44686 5.49755L8.50731 5.84998L8.19081 5.68358L7.87431 5.84998L7.93475 5.49755L7.6787 5.24796L8.03256 5.19654L8.19081 4.87589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4218 4.87589L11.58 5.19654L11.9339 5.24796L11.6778 5.49755L11.7383 5.84998L11.4218 5.68358L11.1053 5.84998L11.1657 5.49755L10.9097 5.24796L11.2635 5.19654L11.4218 4.87589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6525 4.87583L14.8107 5.19648L15.1646 5.2479L14.9085 5.49749L14.969 5.84992L14.6525 5.68352L14.336 5.84992L14.3964 5.49749L14.1404 5.2479L14.4942 5.19648L14.6525 4.87583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72901 6.67054L1.88726 6.99119L2.24112 7.04261L1.98507 7.2922L2.04551 7.64463L1.72901 7.47823L1.41251 7.64463L1.47296 7.2922L1.21691 7.04261L1.57076 6.99119L1.72901 6.67054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95985 6.67054L5.1181 6.99119L5.47196 7.04261L5.2159 7.2922L5.27635 7.64463L4.95985 7.47823L4.64335 7.64463L4.70379 7.2922L4.44774 7.04261L4.8016 6.99119L4.95985 6.67054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19081 6.67054L8.34906 6.99119L8.70291 7.04261L8.44686 7.2922L8.50731 7.64463L8.19081 7.47823L7.87431 7.64463L7.93475 7.2922L7.6787 7.04261L8.03256 6.99119L8.19081 6.67054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4216 6.67054L11.5799 6.99119L11.9337 7.04261L11.6777 7.2922L11.7381 7.64463L11.4216 7.47823L11.1051 7.64463L11.1656 7.2922L10.9095 7.04261L11.2634 6.99119L11.4216 6.67054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6525 6.67054L14.8107 6.99119L15.1646 7.04261L14.9085 7.2922L14.969 7.64463L14.6525 7.47823L14.336 7.64463L14.3964 7.2922L14.1404 7.04261L14.4942 6.99119L14.6525 6.67054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72901 8.46593L1.88726 8.78658L2.24112 8.83799L1.98507 9.08759L2.04551 9.44001L1.72901 9.27362L1.41251 9.44001L1.47296 9.08759L1.21691 8.83799L1.57076 8.78658L1.72901 8.46593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95973 8.46593L5.11798 8.78658L5.47183 8.83799L5.21578 9.08759L5.27623 9.44001L4.95973 9.27362L4.64323 9.44001L4.70367 9.08759L4.44762 8.83799L4.80148 8.78658L4.95973 8.46593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19081 8.46605L8.34906 8.7867L8.70291 8.83812L8.44686 9.08771L8.50731 9.44014L8.19081 9.27374L7.87431 9.44014L7.93475 9.08771L7.6787 8.83812L8.03256 8.7867L8.19081 8.46605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4218 8.46605L11.58 8.7867L11.9339 8.83812L11.6778 9.08771L11.7383 9.44014L11.4218 9.27374L11.1053 9.44014L11.1657 9.08771L10.9097 8.83812L11.2635 8.7867L11.4218 8.46605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6525 8.46593L14.8107 8.78658L15.1646 8.83799L14.9085 9.08759L14.969 9.44001L14.6525 9.27362L14.336 9.44001L14.3964 9.08759L14.1404 8.83799L14.4942 8.78658L14.6525 8.46593Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_233_134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.190552,
    y: 0.285271,
    width: 25.9,
    height: 19.43,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_233_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 -3.99973L-3.61256 22.522",
    stroke: "black",
    strokeWidth: 2.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.9048,
    height: 19.4286,
    fill: "white",
    transform: "translate(0.190552 0.28611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UK-Flag.3beca7ba808898f56dd9baff7497965e.svg";
export { ForwardRef as ReactComponent };